// @spec GHG-STR-005
// @spec GHG-STR-069
// @spec GHG-STR-077
// @spec GHG-STR-085
'use client';

import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/ghg-sources')({
  component: () => <Navigate to="/ghg/activity-groups" replace />,
});
